"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const query_string_1 = __importDefault(require("query-string"));
const translations_1 = __importDefault(require("../../../common/translations"));
const themeHelper_1 = require("../../../common/helpers/themeHelper");
const services_1 = require("../../../common/services");
const helpers_1 = require("../../../common/helpers/helpers");
const Header_1 = __importDefault(require("../Header/Header"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const BrandScreen_1 = __importDefault(require("./BrandScreen"));
const BrandVenues_1 = __importDefault(require("./BrandVenues"));
const UserProfile_1 = __importDefault(require("./UserProfile"));
const LegacyContentResolver_1 = __importDefault(require("../Other/LegacyContentResolver"));
const useUserToken_1 = require("../../behaviours/useUserToken");
const ContentResolverWrapper = styled_components_1.default.div `
  height: 100%;
  overflow-y: scroll;
`;
const ErrorWrapper = styled_components_1.default.div `
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ErrorMessageText = styled_components_1.default.div `
  width: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  padding: 12px 16px;
  word-break: break-word;
  white-space: normal;
  background-color: #1976d2;
  color: #fff;
  text-align: center;
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const BrandLayout = (props) => {
    const USER_ACTIVATION_DELAY_MS = 30000;
    const TOKEN_CREATED_AT_STORAGE_KEY = "tokenCreatedAt";
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const [appError, setAppError] = (0, react_1.useState)('');
    const [theme, setTheme] = (0, react_1.useState)((0, styles_1.createTheme)());
    const [showBrandInfo, setShowBrandInfo] = (0, react_1.useState)(true);
    const [showRegistrationConfirmation, setShowRegistrationConfirmation] = (0, react_1.useState)(false);
    const [registrationMessage, setRegistrationMessage] = (0, react_1.useState)("");
    const { location, updateStore, history, userData } = props;
    const browserLocale = navigator.language && navigator.language.length > 2
        ? navigator.language.substring(0, 2)
        : navigator.language || 'de'; // Default to 'en' if navigator.language is not available
    const queryParams = query_string_1.default.parse(location.search);
    const currentLocale = queryParams.locale ? queryParams.locale : browserLocale;
    const isHotelListPage = location.pathname === "/venues";
    const handleCloseDialog = () => {
        history.push("/");
    };
    const handleInitialSetupError = (error) => {
        const errorMessage = (error === null || error === void 0 ? void 0 : error.message) || 'Unexpected error';
        setAppError(errorMessage);
        setLoaded(true);
    };
    const getBrandView = (brandImages) => {
        const brandView = {
            L: "",
            XXL: "",
        };
        if (brandImages && brandImages.length > 0) {
            if (Object.prototype.hasOwnProperty.call(brandImages[0], "2:1")) {
                brandView.XXL = brandImages[0]["2:1"].XXL;
                brandView.L = brandImages[0]["2:1"].L;
            }
        }
        return brandView;
    };
    const setupTheme = (appTheme) => {
        const currentThemeFont = document.getElementById("theme-font");
        if (currentThemeFont) {
            currentThemeFont.remove();
        }
        // We create a style tag in the head in which we add the theme font face
        // We do this because injecting the font face globally using styled components results in flickering on rerenders
        // https://github.com/styled-components/styled-components/issues/1593
        if (document && appTheme.fontFamily) {
            const head = document.getElementsByTagName("head")[0];
            const style = document.createElement("style");
            style.setAttribute("id", "theme-font");
            style.innerHTML = appTheme.fontFamily;
            head.appendChild(style);
        }
        setTheme((0, styles_1.createTheme)({
            palette: {
                // we set the mainAppColor as the primary color from backoffice
                // and the primary color as the secondary color from backoffice
                // we do it this way because the material library wants to set the primary color as a default for many small components and those components should be colored in the secondary color
                // main color theme of the app,
                mainAppColor: {
                    main: appTheme.colorPrimary,
                    contrastText: appTheme.colorOnPrimary,
                    light: appTheme.colorPrimaryLighter,
                    dark: appTheme.colorPrimaryDarker,
                },
                // used for buttons, inputs, CTA's styling, other various places where we need this accent
                primary: {
                    main: appTheme.colorSecondary,
                    contrastText: appTheme.colorOnSecondary,
                },
                // not used currently
                secondary: {
                    main: appTheme.colorSecondary,
                    contrastText: appTheme.colorOnSecondary,
                },
                colorAppBar: {
                    main: appTheme.colorAppBar,
                    contrastText: appTheme.colorOnAppBar,
                },
                colorOnAppBar: {
                    main: appTheme.colorOnAppBar,
                    contrastText: appTheme.colorOnAppBar,
                },
                contrastThreshold: 3,
                tonalOffset: 0.2,
            },
            logo: appTheme.logo,
            // MUI typography elements overwrite the font we set in the <head>, so we disable this behaviour by giving it an empty array
            typography: {
                fontFamily: [],
            },
        }));
    };
    const checkinUser = (venueSlug) => __awaiter(void 0, void 0, void 0, function* () {
        const userToken = localStorage.getItem("userToken");
        const checkin = yield services_1.apiService.checkinUser("de", userToken, venueSlug);
        if (checkin.status === "success") {
            history.push({
                pathname: `/${checkin.venue.slug}`,
            });
        }
    });
    const checkForExistingUserToken = (clientId) => __awaiter(void 0, void 0, void 0, function* () {
        const existingToken = localStorage.getItem("userToken");
        if (existingToken) {
            return existingToken;
        }
        const token = yield (0, useUserToken_1.useUserToken)({ clientId });
        localStorage.setItem("userToken", token);
        localStorage.setItem(TOKEN_CREATED_AT_STORAGE_KEY, new Date().toISOString());
        setTimeout(() => {
            services_1.apiService.activateUser(token);
        }, USER_ACTIVATION_DELAY_MS);
        return token;
    });
    const initialSetup = () => __awaiter(void 0, void 0, void 0, function* () {
        const appData = yield services_1.apiService.getAppData(currentLocale);
        if (appData.usercentricsApiKey) {
            helpers_1.Helpers.loadUsercentricsScript(() => { }, appData.usercentricsApiKey, currentLocale);
        }
        else {
            window.usercentrics = null;
        }
        document.title = appData.brandName;
        const brandInfo = yield services_1.apiService.getBrandInfo(appData.brandSlug, currentLocale);
        const brandParams = { slug: appData.brandSlug, brand: appData.brandName };
        if (queryParams.status === "failure" && queryParams.message) {
            setShowRegistrationConfirmation(true);
            setRegistrationMessage(queryParams.message);
        }
        const userToken = yield checkForExistingUserToken(appData.brandId);
        services_1.apiService
            .getUserData(userToken)
            .then((data) => updateStore("userData", data));
        translations_1.default.locale = currentLocale;
        translations_1.default.currentLocale();
        const appTheme = (0, themeHelper_1.getAppTheme)(brandParams, appData.theme);
        updateStore("userBrowserLanguage", navigator.languages && navigator.languages.length > 0 ? navigator.languages[0].slice(0, 2) : 'de');
        updateStore("hotelView", getBrandView(appData.images));
        updateStore("brandInfo", brandInfo);
        updateStore("urlParams", brandParams);
        updateStore("appData", appData);
        updateStore("imprintUrl", appData.imprintUrl);
        updateStore("baseUrl", "/");
        updateStore("userLandedOn", location.pathname);
        updateStore("appIds", {
            android: appData.androidAppId,
            itunes: appData.itunesId,
        });
        setupTheme(appTheme);
        console.log('userData:', userData);
        console.log('brandImages:', appData.images);
        console.log('navigator.languages:', navigator.languages);
        if (appData.autocheckin) {
            checkinUser(appData.autocheckin);
            return;
        }
        if (!appData.showBrandInfo) {
            setShowBrandInfo(false);
            updateStore("isHeaderTransparent", false);
        }
        setTimeout(() => {
            setLoaded(!loaded);
        }, 500);
    });
    (0, react_1.useEffect)(() => {
        setAppError('');
        initialSetup().catch(handleInitialSetupError);
    }, []);
    if (!loaded) {
        return (react_1.default.createElement("div", { className: "overlay" },
            react_1.default.createElement(Loader_1.default, null)));
    }
    if (appError) {
        return (react_1.default.createElement(ErrorWrapper, { "data-testid": "error-wrapper" },
            react_1.default.createElement(ErrorMessageText, null, appError)));
    }
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(react_1.default.Fragment, null,
            !isHotelListPage && react_1.default.createElement(Header_1.default, null),
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: "/", render: () => (showBrandInfo ? react_1.default.createElement(BrandScreen_1.default, null) : react_1.default.createElement(BrandVenues_1.default, null)), exact: true }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/venues", render: () => (react_1.default.createElement("div", { className: "mdc-top-app-bar--fixed-adjust" },
                        react_1.default.createElement("section", { className: "route-section" },
                            react_1.default.createElement(BrandVenues_1.default, null)))) }),
                userData && userData.loginProviders && userData.loginProviders.length > 0 && (react_1.default.createElement(react_router_dom_1.Route, { path: "/profile", render: () => (react_1.default.createElement("div", { className: "mdc-top-app-bar--fixed-adjust" },
                        react_1.default.createElement("section", { className: "route-section" },
                            react_1.default.createElement(material_1.Toolbar, null),
                            react_1.default.createElement(UserProfile_1.default, null)))) })),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/directory/:type/:name", render: () => (react_1.default.createElement("div", { className: "mdc-top-app-bar--fixed-adjust" },
                        react_1.default.createElement("section", { className: "route-section" },
                            react_1.default.createElement(material_1.Toolbar, null),
                            react_1.default.createElement(ContentResolverWrapper, null,
                                react_1.default.createElement(LegacyContentResolver_1.default, { collection: "brand" }))))) })),
            react_1.default.createElement(material_1.Dialog, { open: showRegistrationConfirmation, TransitionComponent: Transition, keepMounted: true, onClose: handleCloseDialog, "aria-describedby": "alert-dialog-slide-description" },
                react_1.default.createElement(material_1.DialogTitle, null, registrationMessage),
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement(material_1.Button, { onClick: handleCloseDialog }, "Ok"))))));
};
const mapStoreToProps = (store) => ({
    isHeaderTransparent: store.getValue("isHeaderTransparent"),
    userData: store.getValue("userData"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(BrandLayout);
